/*
 * The top bar's search field, which opens the search panel (PLT-7168). It is a button, because a
 * click opens a dialog rather than placing a caret, but it keeps the field's look so the bar does not
 * change: 40px tall, `full` radius, a `gray-100` well with no border, `lg` of air before the
 * magnifier and `md` between the magnifier and the hint (design/40-shell-and-pages.md "Top bar").
 * The size and margins come from the wrapper's `.search` in `unified-top-bar.module.css`, which the
 * Arvo console's decision search shares.
 *
 * A well, not a hairline on white: this field sits in chrome between two `full`-radius pills, where
 * an inset well is the licensed use of a gray tint (`design/10-foundations.md` "The page is always
 * white") and the tinted tier is as loud as the top bar may get.
 */
.trigger {
  display: flex;
  align-items: center;
  gap: var(--space__md);
  box-sizing: border-box;
  inline-size: 100%;
  block-size: var(--space__3xl);
  padding-inline: var(--space__lg);
  border: none;
  border-radius: var(--border-radius__full);
  background: var(--color__gray-100);
  color: var(--color__gray-600);
  font-family: var(--font-family__primary);
  font-size: var(--font-size__md);
  font-weight: var(--font-weight__regular);
  line-height: var(--line-height__none);
  text-align: start;
  /* It reads as a place to type, so it points like one. */
  cursor: text;
}

/* One step down the same gray, so the field is the only thing that changes (DESIGN.md rule 25). */
.trigger:hover {
  background: var(--color__gray-200);
}

.trigger:focus-visible {
  outline: var(--focus-ring__width) solid var(--focus-ring__color);
  outline-offset: var(--focus-ring__offset);
}

.triggerIcon {
  flex: none;
  inline-size: 1rem;
  block-size: 1rem;
}

/*
 * The hint, `gray-600` like the magnifier: `gray-500` is 4.4:1 on the `gray-100` well, under the AA
 * floor (`design/10-foundations.md` "Text contrast"). It truncates when the field shrinks toward its
 * 160px floor.
 */
.triggerHint {
  min-inline-size: 0;
  overflow-x: clip;
  text-overflow: ellipsis;
  white-space: nowrap;
}
